import { render, staticRenderFns } from "./levels-description.vue?vue&type=template&id=16711cd2&scoped=true&"
import script from "./levels-description.vue?vue&type=script&lang=ts&"
export * from "./levels-description.vue?vue&type=script&lang=ts&"
import style0 from "./levels-description.vue?vue&type=style&index=0&id=16711cd2&lang=scss&scoped=true&"
import style1 from "./levels-description.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16711cd2",
  null
  
)

export default component.exports